'use client';

import {
  ArticleCard,
  AuthorByline,
  CardDate,
  Excerpt,
  Eyebrow,
  Image,
  Title,
} from '@/app_components/ArticleSections/ArticleCards/ArticleCard';
import { Link } from '@/app_components/common/Link';
import { useHideDateStamp } from '@/app_lib/hooks/useHideDateStamp';
import type { ArticlePreviewHero } from '@/app_lib/types/ArticlePreview';
import { getPrimarySection } from '@/app_lib/utils/utils';

export const ArticleCardHero = ({
  article,
  className,
  priority,
  dataCy,
  hideDateStamp = false,
}: {
  article: ArticlePreviewHero;
  className?: string;
  priority?: boolean;
  dataCy?: string;
  hideDateStamp?: boolean;
}) => {
  const primarySection = getPrimarySection(article.primarySectionId, article.sections);
  const hideDateFromExperiment = useHideDateStamp();
  const hideDate = hideDateStamp || hideDateFromExperiment;

  return (
    <ArticleCard
      as={Link}
      className={className}
      dataCy={dataCy}
      href={article.url}
      variant='hero'
    >
      <Image
        disableDimming
        image={article.image}
        imageAlt={article.imageAlt}
        priority={priority}
        url={article.url}
        variant='hero'
      />
      <div className='flex flex-col gap-xl lg:w-1/2 justify-center p-sm lg:p-0 lg:pr-10'>
        <div className='flex flex-col gap-md'>
          {primarySection && (
            <Eyebrow
              sectionName={primarySection.name}
              sectionUrl={primarySection.url}
              variant='hero'
            />
          )}
          <Title
            title={article.title}
            url={article.url}
            variant='hero'
          />
          <Excerpt
            excerpt={article.excerpt}
            variant='hero'
          />
        </div>
        <div className='flex flex-col'>
          <AuthorByline
            authors={article.authors}
            variant='hero'
          />
          <CardDate
            dateGmt={article.dateGmt}
            hidden={hideDate}
            variant='hero'
          />
        </div>
      </div>
    </ArticleCard>
  );
};
